import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Topheader } from './../../components/Topheader';
import { CustomerDetailsId } from '../../actions/CustomerAction';
import { setupPaymentGatewayProperties } from '../../helpers/functions/paymentGateway.properties.js';
import { getCsrfToken, createRecurrence } from '../../actions/PaymentAction';
import { Buttons } from './../../components/Buttons';
import { ErrorMessage } from './../../components/Message/ErrorMessage';
import { initialAddressSettings, initialAddressState } from '../../helpers/addressSettingsState';
import { SuccessMessage } from './../../components/Message/SuccessMessage';
import classes from './Customers.module.scss';
import { Container, Grid, Tooltip, Checkbox, TextField, Autocomplete } from '@mui/material';
import LoadingOverlay from 'react-loading-overlay';
import { getLocationPaymentGateway } from '../../helpers/commonFunction';
import { validateZipCode } from '../../helpers/functions/validateZipCode';
import { userSettings, settingDataByCompanyId, getUserSettingsByLocationId } from '../../actions/AdminUserAction';
import moment from 'moment';
import validator from '../../helpers/checkValidations';
import { rules } from '../../constants/IntakeFormConstants';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { LinkTabs } from '../../components/Tabs';
import FeatureFlagButtonDisabler from '../../components/FeatureFlagButtonDisabler/FeatureFlagButtonDisabler';
import AddressFieldsDropDown from '../../components/AddressFieldsDropDown/AddressFieldsDropDown';
import { checkAddressEnabled, validateCityInAddress } from '../../helpers/functions/addressFieldsEnabled';
import { handleAddressSettingError } from '../../helpers/functions/validateAddressfields';
import DatePickerInput from '../../components/DatePicker/DatePickerInput.js';
import SelectAccount from '../../components/SelectAccount/SelectAccount';
import { DataGetApiV2 } from '../../helpers/PostDataApi';
import config from '../../constants/config';
import recurrenceConstants from '../../constants/recurrence';
import FeeDisplay from '../../components/FeeDisplay';
import commonStrings from '../../constants/commonStrings.js';
import AmountTextField from '../../components/FeeDisplay/AmountTextField';
import FeatureFlag from '../../components/FeatureFlag/FeatureFlag';

class CustomerDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      sideShow: true,
      REFUND: false,
      isLoading: true,
      isSubmit: false,
      customer_receipt: false,
      ach_recurring: false,
      credit_recurring: true,
      firstName: '',
      lastName: '',
      createdBy: '',
      companyId: '',
      recurrenceType: 'C',
      routingNumber: null,
      accountNumber: null,
      email: '',
      phone: '',
      customFields: [],
      paytraceCredentials: {},
      ...initialAddressSettings,
      ...initialAddressState,
      base_amount: '',
      amount: '',
      frequency: '',
      customer_id: '',
      masked_card_number: '',
      StartDate: new Date(),
      EndDate: new Date(),
      totalCount: 1,
      misMatchError: [],
      csrf: { 'csrf-token': '', 'csrf-secret': '' },
      error: {
        customer_idError: false,
        amountError: false,
        phoneError: false,
        totalCountError: false,
        firstNameError: false,
        lastNameError: false,
      },
      settings: {},
      permissions: {},
      showMaskedNumberError: false,
      customerData: {},
      currentLocation: {},
      savedPaymentMethods: [],
      selectedPaymentMethod: {},
      paymentType: '', // Props for Fee Display component

      /** @type {import('../../../../types/fees.js').CalculationViewResult | {}} */
      calculationResult: {},
    };
  }

  componentDidMount() {
    const paymentGateway = getLocationPaymentGateway();
    this.setPaymentGatewayProperties(paymentGateway);
    this.fetchAddressInfo();
    this.getCustomerDetails();
    this.getCsrfTokens();
    this.settingDataByCompanyId();
    this.setUserData();
    this.getPaymentVault();
  }

  componentDidUpdate(_prevProps, prevState) {
    if (this.state.customerData?._id !== prevState.customerData?._id) {
      this.setState({ selectedPaymentMethod: {}, savedPaymentMethods: [] });
      this.getPaymentVault();
    }
  }

  setUserData() {
    let userData = JSON.parse(localStorage.getItem('user'));
    this.setState({
      createdBy: userData._id,
      companyId: userData.company._id,
      permissions: userData.permissions,
      settings: userData.settings ? userData.settings : {},
    });
  }

  setPaymentGatewayProperties(paymentGatewayVal) {
    const { misMatchErrors, paytraceCredentials, multipassCredentials } =
      setupPaymentGatewayProperties(paymentGatewayVal);
    if (misMatchErrors) {
      this.setState({ misMatchErrors });
    } else {
      paymentGatewayVal === 'paytrace'
        ? this.setState({ paytraceCredentials })
        : this.setState({ multipassCredentials });
    }
  }

  getPaymentVault() {
    const getLegacyCard = () => {
      return {
        maskedValue: this.state.customerData?.masked_card_number,
        paymentType: this.state.customerData?.creditOrDebit?.toLowerCase() ?? commonStrings.debit,
        creditOrDebit: this.state.customerData?.creditOrDebit,
        accountType: this.state.customerData?.cardType ? this.state.customerData.cardType : 'No Card Type',
        gatewayPaymentMethodId: this.state.customerData?.cardWalletID,
      };
    };
    if (this.state.currentLocation?.ACHPaymentVault) {
      if (this.state.customerData?._id?.length > 0) {
        let paymentMethodsArray = [];
        const query = {
          customerId: this.state.customerData._id,
        };

        DataGetApiV2(config.BASEURL + 'getPaymentVault', query)
          .then((response) => {
            if (response.data?.paymentMethods) {
              // if any paymentMethods are in paymentVault add it to array
              paymentMethodsArray = [...response.data.paymentMethods];
            }
          })
          .catch((_error) => {
            const misMatchError = ['Could not get account data.'];
            this.setState({ misMatchError, selectedPaymentMethod: {} });
          })
          .finally(() => {
            paymentMethodsArray.push(getLegacyCard());
            this.setState({ savedPaymentMethods: [...paymentMethodsArray] });
          });
      } else {
        this.setState({ selectedPaymentMethod: {} });
      }
    } else if (this.state.customerData?.masked_card_number) {
      // add legacy card to payment methods even if no payment vault and preselect it.
      const legacyCard = getLegacyCard();
      this.setState({
        savedPaymentMethods: [getLegacyCard()],
        selectedPaymentMethod: legacyCard,
        paymentType: legacyCard.paymentType,
      });
    }
  }

  getCsrfTokens() {
    this.props.getCsrfToken().then((res) => {
      this.setState({ csrf: { ...res.payload.paymentData.data } });
    });
  }

  settingDataByCompanyId() {
    this.setState({ isLoading: true });
    const location = JSON.parse(localStorage.getItem('locationPaydetails'));
    this.setState({ currentLocation: location });
    // Get the setting Data from the locationId and companyId.
    this.props
      .getUserSettingsByLocationId({ location: location ? location.id : '' })
      .then((res) => {
        this.setState({ settings: res.payload.userData.data.response });
      })
      .catch((_err) => {});
  }

  changeFrequency(value) {
    const count = +this.state.totalCount > 0 ? this.state.totalCount : 0;
    let endDate = moment(this.state.StartDate);
    let EndDate = endDate;
    switch (value) {
      case '1':
        EndDate = endDate.add(count, 'Y');
        break;
      case '8':
        EndDate = endDate.add(count / 2, 'Y');
        break;
      case 'A':
        EndDate = endDate.add(count * 3, 'M');
        break;
      case '2':
        EndDate = endDate.add(count * 4, 'M');
        break;
      case '9':
        EndDate = endDate.add(count * 2, 'M');
        break;
      case '3':
        EndDate = endDate.add(count, 'M');
        break;
      case '4':
        EndDate = endDate.add(count * 2, 'W');
        break;
      case '7':
        EndDate = endDate.add(count / 2, 'M');
        break;
      case '5':
        EndDate = endDate.add(count, 'W');
        break;
      default:
        EndDate = endDate.add(count, 'd');
        break;
    }
    this.setState({ EndDate: EndDate.toDate() });
  }

  handleChange(event, _t) {
    let error = {};
    let misMatchError = [];
    let { id, value } = event.target;
    let errorKey = id + 'Error';
    error[errorKey] = validator(id, value);
    this.setState({ [id]: value, error, misMatchError, isSubmit: false }, () => {
      if (id === 'frequency' || id === 'StartDate' || id === 'totalCount') {
        this.changeFrequency(this.state.frequency);
      }
    });
  }
  getCustomerDetails() {
    const {
      match: { params },
    } = this.props;
    this.setState({ isLoading: true });
    this.props.CustomerDetailsId(params).then((res) => {
      let transaction = res.payload.customerData.data;
      if (transaction.success) {
        const sendCustomerReceipt = transaction.response.email ? true : false;
        this.setState({
          ...transaction.response, // all of the data is in top level of state
          billingAddress: validateCityInAddress(transaction.response.billingAddress),
          customer_receipt: sendCustomerReceipt,
          ...{ customer_id: transaction.response.customer_id },
          isLoading: false,
          customerData: transaction.response,
        });
      }
    });
  }

  inputFormValidation(value) {
    if (this.state[value] === '') {
      delete this.state[value];
    }
  }

  checkPhone(key) {
    return key === 'phoneNumber' || key === 'phone';
  }

  checkEmail(key) {
    return key === 'email';
  }

  checkPaymentValid(result) {
    return result !== undefined && result.type === 'PAYMENT_ERROR';
  }

  validatePayloadError(result) {
    return (
      (result.payload?.error &&
        (result.payload.error.data?.statusCode === 403 || result.payload.error.status === 403)) ||
      (result.payload?.error &&
        (result.payload.error.data?.statusCode === 400 || result.payload.error.status === 400)) ||
      (result.payload?.error && (result.payload.error.data?.statusCode === 401 || result.payload.error.status === 401))
    );
  }

  fetchAddressInfo() {
    const location = JSON.parse(localStorage.getItem('locationPaydetails'));
    this.props.getUserSettingsByLocationId({ location: location ? location.id : '' }).then((resp) => {
      if (resp.type === 'USER_SUCCESS' && resp.payload.userData.status === 200) {
        this.setState({
          addressSettings: {
            ...this.state.addressSettings,
            shippingAddress: resp.payload.userData.data?.response?.virtualTerminalSettings?.shippingAddress,
            billingAddress: resp.payload.userData.data?.response?.virtualTerminalSettings?.billingAddress,
          },
        });
      }
    });
  }

  filterFrequencies(paymentGateway) {
    return recurrenceConstants.frequencies.filter((frequency) => {
      return frequency[paymentGateway?.toLowerCase()];
    });
  }

  handleSubmitRecurring(e, _t) {
    e.preventDefault();

    let misMatchError = [];
    let state = this.state;
    let error = {};
    let successMessages = false;
    let errorFlag = false;
    this.setState({ isSubmit: true });
    this.inputFormValidation('lastName');
    this.inputFormValidation('phone');
    this.inputFormValidation('phoneNumber');
    this.inputFormValidation('cardType');
    this.inputFormValidation('creditOrDebit');
    this.inputFormValidation('customerAccountNumber');
    this.inputFormValidation('customerAddress');
    this.inputFormValidation('customerCity');

    if (state.totalCount < 1) {
      error['totalCountError'] = true;
      errorFlag = true;
    }

    if (Object.keys(state.selectedPaymentMethod)?.length === 0) {
      misMatchError.push('No payment method selected.');
      errorFlag = true;
    }

    if (state.amount?.match(/^0\.[^1-9]*$/)) {
      misMatchError.push('Amount cannot be zero.');
      errorFlag = true;
    }

    if (!state.frequency) {
      misMatchError.push('Please select a frequency.');
      errorFlag = true;
    }

    const addressError = handleAddressSettingError(this.state);
    if (addressError.length > 0) {
      misMatchError = addressError;
      this.setState({ misMatchError });
      return false;
    }

    const zipCodeErrors = validateZipCode(this.state);
    if (zipCodeErrors.length > 0) {
      this.setState({ misMatchError: zipCodeErrors });
      return false;
    }

    Object.keys(state).forEach((key) => {
      if (state[key]) {
        if (this.checkPhone(key)) {
          return (error[key + 'Error'] = false);
        }
        if (this.checkEmail(key)) {
          if (!this.state.customer_receipt) {
            return (error[key + 'Error'] = false);
          }
        }
        return validator(key, state[key])
          ? ((error[key + 'Error'] = true), (errorFlag = true))
          : (error[key + 'Error'] = false);
      } else {
        if (key === 'zip' || key === 'address') {
          return error[key + 'Error'];
        } else if (key === 'masked_card_number' && Object.keys(state.selectedPaymentMethod)?.length > 0) {
          return error[key + 'Error'];
        } else {
          if (state[key] === '' || (typeof state[key] === 'string' && state[key].trim() === '')) {
            return (error[key + 'Error'] = true), (errorFlag = true);
          } else {
            return error[key + 'Error'];
          }
        }
      }
    });

    if (this.state.paymentType === '') {
      misMatchError.push(
        'Could not identify the payment type. Please re-add the saved card for this customer, or add a different card before retrying.'
      );
      errorFlag = true;
    }

    if (errorFlag) {
      window.scrollTo(0, 0);
      this.setState({ misMatchError, error, successMessages });
      return false;
    } else {
      if (window.confirm('Are you sure you want to start recurring?')) {
        this.setState({ isLoading: true });
        this.props.createRecurrence(this.state, this.state.csrf, this.state.paytraceCredentials).then((result) => {
          if (result !== undefined && result.type === 'PAYMENT_SUCCESS') {
            window.scrollTo(0, 0);
            this.setState({ isLoading: false, successMessages: true, misMatchError }, () => {
              setTimeout(() => {
                this.setState({ successMessages: false });
                this.setState({ redirect: true });
              }, 2000);
            });
          }
          if (this.checkPaymentValid(result)) {
            window.scrollTo(0, 0);
            if (this.validatePayloadError(result)) {
              let message =
                result.payload.error.data?.message ||
                result.payload.error.response?.data?.message ||
                'Unknown Error occurred';
              misMatchError.push(message);
              this.setState({
                isLoading: false,
                misMatchError,
                successMessages,
              });
            }
            if (this.props.info.paymentInfo.data?.response?.length > 0) {
              let responseErrors = JSON.parse(this.props.info.paymentInfo.data.response);
              if (responseErrors.response_code === 1) {
                for (let key in responseErrors.errors) {
                  let i = 0;
                  misMatchError.push(responseErrors.errors[key][i] + '\n');
                }
                this.setState({
                  isLoading: false,
                  misMatchError,
                  successMessages,
                });
              } else {
                misMatchError.push(responseErrors.approval_message);
              }
            }
            this.setState({
              isSubmit: false,
              isLoading: false,
              misMatchError,
              successMessages,
            });
          }
        });
      }
    }
  }

  handleDateChange = (date, key) => {
    this.setState({ [key]: date }, () => {
      if (key == 'StartDate') this.changeFrequency(this.state.frequency);
    });
  };
  setClientValue(val) {
    let misMatchError = [];
    if (val !== null) {
      this.setState({ frequency: val.value, misMatchError }, () => {
        this.changeFrequency(val.value);
      });
    } else {
      this.setState({ frequency: '', misMatchError });
    }
  }
  handleChangeCheckbox(event) {
    this.setState({ [event.target.id]: event.target.checked });
  }

  handleChangeRecurringCheck(event) {
    if (event.target.id === 'ach_recurring') {
      this.setState({ ach_recurring: true, credit_recurring: false, recurrenceType: 'A' });
    } else {
      this.setState({ ach_recurring: false, credit_recurring: true, recurrenceType: 'C' });
    }
  }

  handleAdd() {
    this.setState({ isOpen: true });
  }

  handleLabels = (data) => {
    const values = [...this.state.customFields];

    values.push({ value: null, label: data.LableName });
    this.setState({ customFields: values });
  };
  handleRemove(i) {
    const values = [...this.state.customFields];
    values.splice(i, 1);
    this.setState({ customFields: values });
  }

  handleSettingChanges(e, name, obj) {
    const settings = { ...this.state.settings };
    if (typeof obj === 'object') {
      settings[name] = obj.value;
    } else {
      settings[name] = e.target.value;
    }
    this.setState({ settings }, () => {
      this.getCsrfTokens();
    });
  }

  handleChangeAddress = (event, type, isBillingAddressSameAsShippingAddress = false) => {
    let { id, value } = event.target;
    if (type === 'shippingAddress' || isBillingAddressSameAsShippingAddress) {
      const addressShipping = {
        ...this.state.shippingAddress,
        [id]: value,
      };
      this.setState({ shippingAddress: addressShipping });
    }
    if (type === 'billingAddress') {
      const billingAddress = {
        ...this.state.billingAddress,
        [id]: value,
      };
      this.setState({ billingAddress });
    }
  };

  handleIsBillingAddressSameAsShippingAddress = (isBillingAddressSameAsShippingAddress = false) => {
    if (isBillingAddressSameAsShippingAddress) {
      this.setState({ shippingAddress: { ...this.state.billingAddress } });
    }
  };

  handleChangePaymentMethod(selectedAccountDetails) {
    if (selectedAccountDetails) {
      this.setState({
        selectedPaymentMethod: { ...selectedAccountDetails },
        paymentType: selectedAccountDetails?.paymentType ?? '',
      });
    } else {
      // if removing selected account
      this.setState({
        selectedPaymentMethod: {},
        paymentType: '',
      });
    }
  }

  render() {
    const { t } = this.props;
    const { redirect } = this.state;
    const {
      match: { params },
    } = this.props;

    return (
      <div className="rightPanel">
        {redirect ? <Redirect to="/Recurring" /> : ''}
        <Topheader />
        <div className="contentPart">
          <LinkTabs id={params.id} />
          <LoadingOverlay active={this.state.isLoading} spinner text="Loading your content...">
            <Container component="main" maxWidth={false}>
              <FeatureFlag name="recurring:write" />
              {this.state.misMatchError.length > 0 ? <ErrorMessage errors={[this.state.misMatchError]} /> : ''}
              {this.state.successMessages ? (
                <SuccessMessage successes={[this.props.info.paymentInfo.data.message]} />
              ) : (
                ''
              )}
              {this.state.showMaskedNumberError ? (
                <ErrorMessage errors={['The card details are empty. Go to Customers to add the card details.']} />
              ) : (
                ''
              )}
              <form noValidate>
                <input type="hidden" name="_csrf" value={this.state.csrf['csrf-token']} />
                <input type="hidden" name="_csrfSecret" value={this.state.csrf['csrf-secret']} />
                {this.state.error.customer_idError ? (
                  <h3 className="errorMsg">Unable to process recurring as user card details are empty.</h3>
                ) : (
                  ''
                )}
                {!this.props.user.permissions.recurring ? (
                  <h3 className="errorMsg">Kindly contact to super admin for recurring access.</h3>
                ) : (
                  ''
                )}
                {this.state.status_code === 'P' ? (
                  <h3 className="errorMsg">
                    This transaction not settle yet! please try after{' '}
                    {24 - Math.round((new Date() - new Date(this.state.DATETIME)) / 3600000)} hours.
                  </h3>
                ) : (
                  ''
                )}
                {this.state.status_code === 'V'
                  ? 'This transaction has been voided on ' +
                    (this.state.UPDATE_VOID_DATE
                      ? new Date(this.state.UPDATE_VOID_DATE).toLocaleString()
                      : new Date().toLocaleString())
                  : ''}
                {this.state.REFUND ? (
                  <h3 className={classes.successMsg}>
                    This transaction has been refunded on {new Date(this.state.REFUND_DATE).toString()}{' '}
                  </h3>
                ) : (
                  ''
                )}
                <div className="ViewTxnFormBox">
                  <Grid container item lg={9} marginBottom={3}>
                    <Grid item container columnSpacing={3} rowSpacing={3}>
                      <Grid item>
                        <TextField
                          id="firstName"
                          onChange={(e) => this.handleChange(e)}
                          error={this.state.error && this.state.error.firstNameError}
                          helperText={this.state.error.firstNameError ? rules.firstName.messages.characterlimit : ''}
                          type="text"
                          label={t('FirstName')}
                          value={this.state.firstName ? this.state.firstName : ' '}
                          fullWidth
                          variant="standard"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          id="lastName"
                          onChange={(e) => this.handleChange(e)}
                          error={this.state.error && this.state.error.lastNameError}
                          helperText={this.state.error.lastNameError ? rules.lastName.messages.characterlimit : ''}
                          type="text"
                          label={t('LastName')}
                          value={this.state.lastName ? this.state.lastName : ' '}
                          fullWidth
                          variant="standard"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          error={this.state.error.emailError}
                          id="email"
                          type="email"
                          label={t('Email')}
                          value={this.state.email ? this.state.email : ''}
                          onChange={(e) => this.handleChange(e)}
                          fullWidth
                          variant="standard"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          id="phone"
                          type="text"
                          label={t('Phone')}
                          value={this.state.phone}
                          fullWidth
                          onChange={(e) => this.handleChange(e)}
                          variant="standard"
                        />
                      </Grid>
                    </Grid>
                    <Grid item container rowSpacing={2} direction="row">
                      {checkAddressEnabled(this.state.addressSettings?.billingAddress) && (
                        <Grid item md={12} sm={12} marginTop={3}>
                          <AddressFieldsDropDown
                            type="billing"
                            state={this.state}
                            handleChange={this.handleChangeAddress}
                            handleSameAddress={this.handleIsBillingAddressSameAsShippingAddress}
                          />
                        </Grid>
                      )}
                      {checkAddressEnabled(this.state.addressSettings?.shippingAddress) && (
                        <Grid item md={12} sm={12}>
                          <AddressFieldsDropDown
                            type="shipping"
                            state={this.state}
                            handleChange={this.handleChangeAddress}
                            handleSameAddress={this.handleIsBillingAddressSameAsShippingAddress}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                  <Grid id="recurring-data-container" paddingTop={'50px'} columnSpacing={2} rowSpacing={3} container>
                    <Grid item xs={12} sm={12}>
                      <label>
                        <b>Payment Details</b>
                      </label>
                    </Grid>
                    <Grid item container xs={12} md={8} lg={8} rowSpacing={3} columnSpacing={2}>
                      {this.state.currentLocation?.ACHPaymentVault && this.state.savedPaymentMethods?.length > 0 ? (
                        <Grid item xs={12} md={6}>
                          <SelectAccount
                            paymentMethods={this.state.savedPaymentMethods}
                            selectAccount={(option) => {
                              this.handleChangePaymentMethod(option);
                            }}
                            selectedAccount={this.state.selectedPaymentMethod}
                            showType={'all'}
                          />
                        </Grid>
                      ) : (
                        <Grid item xs={12} sm={6}>
                          <TextField
                            id="MASKCARDNUMBER"
                            type="text"
                            label={t('cardNumber')}
                            value={
                              this.state.MASKCARDNUMBER ? this.state.MASKCARDNUMBER : this.state.masked_card_number
                            }
                            disabled={true}
                            fullWidth
                            onChange={(e) => this.handleChange(e)}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} md={6}>
                        <AmountTextField
                          id="base_amount"
                          label={t('Amount')}
                          amount={this.state.base_amount}
                          setAmount={(newAmount) => {
                            this.setState({
                              base_amount: newAmount,
                              error: {
                                ...this.state.error,
                                base_amountError: !newAmount,
                              },
                            });
                          }}
                          error={this.state.error.base_amountError}
                          required
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <label>
                          <b>Recurring Billing Schedule</b>
                        </label>
                      </Grid>
                      <Grid item container rowSpacing={3} columnSpacing={2} lg={12}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={this.state.error.totalCountError}
                            inputProps={{ min: 1 }}
                            required
                            id="totalCount"
                            type="number"
                            label={t('Number of Billing Cycles')}
                            value={this.state.totalCount}
                            onChange={(e) => this.handleChange(e)}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            id="frequencyTypeInput"
                            data-cy="frequencyTypeInput"
                            autoHighlight
                            options={this.filterFrequencies(this.state.currentLocation?.gateway)}
                            renderInput={(params) => <TextField {...params} label="Frequency Type" />}
                            onChange={(e, val) => this.setClientValue(val)}
                          />
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        container
                        columnSpacing={2}
                        rowSpacing={3}
                        xs={12}
                        justifyContent={'flex-start'}
                        direction={'row'}
                      >
                        <Grid
                          item
                          container
                          flexWrap={'nowrap'}
                          justifyContent={'center'}
                          columnSpacing={2}
                          rowSpacing={3}
                          sm={6}
                        >
                          <Grid item>
                            <Tooltip
                              title="If the Start Date is today's date, the first payment will take place on the following day."
                              aria-label="add"
                              style={{ position: 'relative', top: '25%', left: 0 }}
                            >
                              <InfoOutlinedIcon color="disabled" />
                            </Tooltip>
                          </Grid>
                          <Grid item xs={10} md={10} lg={11}>
                            <DatePickerInput
                              id="StartDate"
                              label={t('StartDate')}
                              value={this.state.StartDate}
                              onChange={(date) => {
                                this.handleDateChange(date, 'StartDate');
                              }}
                              format="MM/dd/yyyy"
                              closeOnSelect
                              unstyled
                            />
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <DatePickerInput
                            id="EndDate"
                            label={t('EndDate')}
                            value={this.state.EndDate}
                            onChange={(date) => {
                              this.handleDateChange(date, 'EndDate');
                            }}
                            format="MM/dd/yyyy"
                            hideCalendar={true}
                            closeOnSelect
                            disabled
                            unstyled
                          />
                        </Grid>
                      </Grid>
                      {this.state?.customFields?.map((field, idx) => {
                        return (
                          // eslint-disable-next-line react/jsx-key
                          <Grid item sm={6} xs={6}>
                            <div key={`${field}-${idx}`}>
                              <TextField
                                id={field.label}
                                type="text"
                                label={field.label}
                                value={field.value || ''}
                                fullWidth
                                onChange={(e) => this.handleChangeCustom(e, t, idx)}
                                autoFocus
                              />
                            </div>
                          </Grid>
                        );
                      })}
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                      <FeeDisplay
                        state={this.state.billingAddress?.state}
                        baseAmount={this.state.base_amount}
                        paymentType={this.state.paymentType}
                        viewAllPrices={false}
                        setCalculationResult={(result) => {
                          this.setState({
                            calculationResult: result,
                            amount: result.totalAmount,
                          });
                        }}
                        setError={(e) => {
                          if (e instanceof Error) {
                            const misMatchError = [e.message];
                            this.setState({ misMatchError });
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid xs={12}>
                    <Grid item xs={12} sm={8} style={{ marginTop: '3.25%' }}>
                      <Checkbox
                        id="customer_receipt"
                        labels="creatNewUser"
                        onChange={(e) => {
                          this.handleChangeCheckbox(e);
                        }}
                        value={this.state.customer_receipt}
                        checked={this.state.customer_receipt}
                        color="primary"
                        inputProps={{
                          'aria-label': 'secondary checkbox',
                        }}
                      />
                      <label>Send an email receipt</label>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      {this.props.user.permissions.recurring ? (
                        <FeatureFlagButtonDisabler name="recurring:write">
                          <Buttons
                            className={classes.ml_2}
                            variant="contained"
                            color="primary"
                            text={t('Recurring')}
                            onClick={(e) => this.handleSubmitRecurring(e, t)}
                          />
                        </FeatureFlagButtonDisabler>
                      ) : (
                        ''
                      )}
                      <Buttons
                        className={classes.ml_2}
                        variant="contained"
                        color="secondary"
                        text={t('Back')}
                        onClick={this.props.history.goBack}
                      />
                    </Grid>
                  </Grid>
                </div>
              </form>
            </Container>
          </LoadingOverlay>
        </div>
      </div>
    );
  }
}

CustomerDetails.propTypes = {
  getCsrfToken: PropTypes.func,
  info: PropTypes.any,
  getUserSettingsByLocationId: PropTypes.func,
  match: PropTypes.any,
  user: PropTypes.any,
  history: PropTypes.any,
  createRecurrence: PropTypes.func,
  t: PropTypes.func,
  CustomerDetailsId: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    info: state.PaymentReducer,
    user: state.AdminUserReducer,
  };
}

export default connect(mapStateToProps, {
  getCsrfToken,
  userSettings,
  settingDataByCompanyId,
  getUserSettingsByLocationId,
  createRecurrence,
  CustomerDetailsId,
})(withTranslation()(CustomerDetails));
